import getUpgradeData from './upgrade-data';
import getDomainPurchaseData from './domain-purchase-data';
import getPaymentURL from './payment-url';

export default {
  getUpgradeData,
  getDomainPurchaseData,
  getPaymentURL,
};
